import React from 'react'
import styles from './ArticleDetailHeadIntro.module.scss'
import { ArticleHeadProps } from '@/elements/widgets/Article/ArticleDetailHead'
import { Link } from '@/components/Link'
import { getLinkPathname } from '@/utils/urls'
import { Image } from '@/components/Image'
import { getAppConfig } from '@/config/config'
import AdLabel from '@/components/AdLabel/AdLabel'

export default function ArticleDetailHeadIntro({
  item,
}: Readonly<{
  item: ArticleHeadProps
}>) {
  const author = item.items[0]?.model?.author
  const config = getAppConfig()
  const basePath = config.basePath

  if (!item.items || item.items.length === 0) {
    return null
  }

  return (
    <div className={styles.head} data-cy={`article-detail-head-intro-${item.items[0].id}`}>
      {item.items.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {item.model.ad === 'true' && <AdLabel />}
            <div className={styles.intro}>
              {item.model.kicker && (
                <h2 className={styles.kicker} data-cy={`article-detail-head-intro-${item.id}_kicker`}>
                  {item.model.kicker}
                </h2>
              )}
              <h3 className={styles.headline} data-cy={`article-detail-head-intro-${item.id}_headline`}>
                {item.model.headline}
              </h3>

              {author &&
                (author?.url ? (
                  <Link href={getLinkPathname(author?.url)} className={styles.author}>
                    <Image
                      image={author?.image}
                      alt={author?.image?.filename ?? 'image'}
                      defaultWidth={136}
                      fallbackImage={`${basePath}/assets/autor-fallback.svg`}
                      priority
                    />
                    <span className={styles['author-name']}>{author?.authorRender}</span>
                  </Link>
                ) : (
                  <div className={styles.author}>
                    <Image
                      image={author?.image}
                      alt={author?.image?.filename ?? 'image'}
                      defaultWidth={36}
                      fallbackImage={`${basePath}/assets/autor-fallback.svg`}
                      priority
                    />
                    <span className={styles['author-name']}>{author?.authorRender}</span>
                  </div>
                ))}
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}
